module.exports = __webpack_public_path__ + "static/media/Charts.0bb81fa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charts.png
// module id = 1046
// module chunks = 0